<template>
    <footer class="footer">
      <div class="container">
        <span class="text-muted">{{ new Date().getFullYear() }} &copy; <a target="_blank" class="white-link" href="https://mmb.irbbarcelona.org">Molecular Modeling and Bioinformatics Group</a></span>
      </div>
    </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>